import { Component } from "react"

class PhoneNumber extends Component{
    constructor(props){
        super(props)
        this.name = "電話番号"
        this.phoneCountry = props.phoneCountry
        this.phoneNumber = props.phoneNumber
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.phoneNumber).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.phoneNumber).trim().length > 0){
            if(this.phoneCountry === "jp"){
                if(this.phoneNumber.length !== 11){
                    callbackDialog("エラー",this.name + "は11文字で入力してください。")
                    return false
                }
                if(!/^[0-9]{11}$/.test(this.phoneNumber)){
                    callbackDialog("エラー",this.name + "で使用できる文字列は0～9の11桁です。")
                    return false
                }
            } else if(this.phoneCountry === "tw" || this.phoneCountry === "fr" || this.phoneCountry === "th"){
                if(this.phoneNumber.length !== 10){
                    callbackDialog("エラー",this.name + "は10文字で入力してください。")
                    return false
                }
                if(!/^[0-9]{10}$/.test(this.phoneNumber)){
                    callbackDialog("エラー",this.name + "で使用できる文字列は0～9の10桁です。")
                    return false
                }
            } else if(this.phoneCountry === "hk"){
                if(this.phoneNumber.length !== 8){
                    callbackDialog("エラー",this.name + "は8文字で入力してください。")
                    return false
                }
                if(!/^[0-9]{8}$/.test(this.phoneNumber)){
                    callbackDialog("エラー",this.name + "で使用できる文字列は0～9の8桁です。")
                    return false
                }
            } else if(this.phoneCountry === "de"){
                if(this.phoneNumber.length > 12){
                    callbackDialog("エラー",this.name + "は12文字以内で入力してください。")
                    return false
                }
                if(!/^[0-9]{11,12}$/.test(this.phoneNumber)){
                    callbackDialog("エラー",this.name + "で使用できる文字列は0～9の12桁までです。")
                    return false
                }
            }
            if(this.phoneCountry === "jp" || this.phoneCountry === "tw" || this.phoneCountry === "fr" || this.phoneCountry === "th" || this.phoneCountry === "de"){
                if(String(this.phoneNumber).substring(0,1) !== "0"){
                    callbackDialog("エラー",this.name + "は0から開始する必要があります。")
                    return false
                }
            }
        }
        return true
    }
}

export default PhoneNumber;